import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-existing-email',
  templateUrl: './existing-email.component.html',
  styleUrls: ['./existing-email.component.css']
})
export class ExistingEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
